import { Link } from 'foundations-components/transitional/components/Link';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { useValidateUrl } from '../hooks/useValidateUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyUrl = props => {
  const propertyValue = usePropertyValue();
  const {
    data: urlValidation
  } = useValidateUrl({
    skip: !propertyValue
  });
  if (urlValidation && urlValidation.isValid && propertyValue) {
    return /*#__PURE__*/_jsx(Link, {
      href: propertyValue,
      external: true,
      truncate: true,
      children: /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
        children: propertyValue
      }))
    });
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: propertyValue
  }));
};
export default FormattedPropertyUrl;